import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top whenever the route's pathname
 * changes. React Router preserves the prior scroll offset across navigations,
 * which lands users partway down a freshly-opened page (e.g. clicking the
 * footer's Privacy / Terms links would start them at the bottom).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset every candidate scroll container. `window`/`documentElement` is the
    // usual scroller, but `index.css` sets `overflow-x: hidden` + `height: 100%`
    // on `<body>`, which (per the CSS spec, `overflow-x: hidden` forces the
    // other axis from `visible` to `auto`) makes `<body>` the actual vertical
    // scroller — so scrolling only `window` would leave it parked mid-page.
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
